"use client"
import React from 'react';
import { motion } from 'framer-motion';
import { Project } from '@/data/projects';
import { fadeInUp, staggerContainer, scaleOnHover } from '../animations';

interface ProjectChallengesProps {
  project: Project;
}

export const ProjectChallenges: React.FC<ProjectChallengesProps> = ({ project }) => {
  return (
    <motion.div
      className="mb-16"
      variants={staggerContainer}
      initial="initial"
      animate="animate"
    >
      <h2 className="text-2xl font-bold text-white mb-6">Project Journey</h2>
      <div className="grid gap-8">
        {project.challenges.map((challenge, index) => (
          <motion.div
            key={index}
            variants={fadeInUp}
            className="relative"
          >
            <div className="grid md:grid-cols-3 gap-6 relative">
              <motion.div
                className="bg-white/5 p-6 rounded-lg relative"
                whileHover={scaleOnHover.hover}
                transition={scaleOnHover.transition}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-pink-500 text-lg">01</span>
                  <h3 className="text-lg font-semibold text-white">Challenge</h3>
                </div>
                <p className="text-gray-300">{challenge}</p>
                <div className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2 text-pink-500 text-xl">
                  →
                </div>
              </motion.div>

              <motion.div
                className="bg-white/5 p-6 rounded-lg relative"
                whileHover={scaleOnHover.hover}
                transition={scaleOnHover.transition}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-pink-500 text-lg">02</span>
                  <h3 className="text-lg font-semibold text-white">Solution</h3>
                </div>
                <p className="text-gray-300">{project.solutions[index]}</p>
                <div className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2 text-pink-500 text-xl">
                  →
                </div>
              </motion.div>

              {project.results[index] && (
                <motion.div
                  className="bg-white/5 p-6 rounded-lg"
                  whileHover={scaleOnHover.hover}
                  transition={scaleOnHover.transition}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-pink-500 text-lg">03</span>
                    <h3 className="text-lg font-semibold text-white">Impact</h3>
                  </div>
                  <p className="text-gray-300">{project.results[index]}</p>
                </motion.div>
              )}
            </div>
            
            {/* Mobile arrows */}
            <div className="md:hidden flex justify-center my-4">
              <span className="text-pink-500 text-xl transform rotate-90">→</span>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}; 